import React, {Fragment} from 'react';
import {Row, Col, Button, message, Modal, Input, Table, Spin} from 'antd';
import moment from 'moment';
import {StyledSubscriptionCard} from './style';
import ApiService from '../../actions/apiService';
import {numberFormatter} from '../../utils/common'

const TextArea = Input.TextArea;

class Subscription extends React.Component {
  
  state = {
    isModalOpen: false,
    isDangerModalOpen: false,
    data: [],
    isLoading: true,
  }
  
  async componentWillMount() {
    await this.getSubscriptions();
  }
  
  getSubscriptions = async () => {
    const response = await ApiService.getMethod('/subscription/info');
    if (response) {
      this.setState({
        data: response,
        isLoading: false,
      })
    }
  }
  
  onConfirm = () => {
    this.setState({
      isModalOpen: true,
    })
  }
  
  handleOk = async () => {
    const {cancelReason, subscriptionID,} = this.state;
    const data = {
      SubscriptionID: subscriptionID,
      Reason: cancelReason
    }
    const resp = await ApiService.cancelSubscription(data);
    if (resp && resp.status === 200) {
      message.success('You have successfully cancel subscription!');
      await this.getSubscriptions();
    }
    else {
      message.error('Something went wrong');
    }
    this.setState({
      isModalOpen: false,
    })
  }
  
  handleYes = () => {
    this.setState({
      isModalOpen: true,
      isDangerModalOpen: false,
    })
  }
  
  handleAccountYes = async () => {
    const resp = await ApiService.deleteAccount();
    if (resp) {
      message.success('Your account has been deleted!');
    }
    else {
      message.error('Something went wrong');
    }
    this.setState({
      isAccountModalOpen: false,
    })
  }
  
  handleCancelSubscription = () => {
    this.setState({
      isDangerModalOpen: true,
    })
  }
  
  handleAccountCancel = () => {
    this.setState({
      isAccountModalOpen: true,
    })
  }
  
  handleCancel = () => {
    this.setState({
      isModalOpen: false,
      isDangerModalOpen: false,
      isAccountModalOpen: false,
      subscriptionID: null,
    })
  }
  
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  
  onCancel = (subscriptionID) => {
    this.setState({
      isModalOpen: true,
      subscriptionID,
    })
  }
  
  render() {
    const {isModalOpen, isDangerModalOpen, isAccountModalOpen, data, isLoading} = this.state;
    const columns = [
      {name: 'subscriptionName', title: 'Name', dataIndex: 'subscriptionName'},
      {name: 'createdDate', title: 'Date', dataIndex: 'createdDate', render: (text) => { return  text ? moment(text).format('YYYY-MM-DD') : '--'}},
      {name: 'nextBillingDate', title: 'Next Billing Date', dataIndex: 'nextBillingDate', render: (text) => { return  text ? moment(text).format('YYYY-MM-DD') : '--'}},
      {name: 'cancelDate', title: 'Canceled Date', dataIndex: 'cancelDate', render: (text) => { return  text ? moment(text).format('YYYY-MM-DD') : '--'}},
      {name: 'nextBillingAmount', title: 'Next Amount Due', dataIndex: 'nextBillingAmount', render: (text) => { return text ? `$${numberFormatter(text)}` : '--'}},
      {name: 'active', title: 'Active?', dataIndex: 'active', render: (text) => { return  text ? 'Yes' : 'No'}},
      {name: '', title: 'Actions', dataIndex: '', render: (text, record) => {
        return record.active && !text.cancelDate ? <Button onClick={() => this.onCancel(record.subscriptionID)}>Cancel</Button> : '--'
      }}
    ]
  
    if (isLoading) {
      return (
        <div style={{textAlign: 'center', marginTop: 50, width: '100%'}}>
          <Spin/>
        </div>
      );
    }
    
    return (
      <Fragment>
        <Row>
          <Col sm={24}>
            <StyledSubscriptionCard title="Current Subscription">
              <Table
                columns={columns}
                size={'small'}
                dataSource={data}
                pagination={false}
              />
            </StyledSubscriptionCard>
          </Col>
        </Row>
        {/*<Row>*/}
          {/*<StyledSubscriptionCard title="Cancel Subscription:">*/}
            {/*<Col sm={24}>*/}
                {/*<Button type={'danger'} onClick={this.handleCancelSubscription}>Cancel Subscription</Button>*/}
            {/*</Col>*/}
          {/*</StyledSubscriptionCard>*/}
        {/*</Row>*/}
        <Row>
          <StyledSubscriptionCard title="Danger Zone:">
            <Col sm={24}>
              <Button type={'danger'} onClick={this.handleAccountCancel}>Delete Account Information</Button>
            </Col>
          </StyledSubscriptionCard>
        </Row>
        <Modal
          visible={isModalOpen}
          title="Cancel Subscription"
          onCancel={this.handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleCancel}>
              Keep Subscription
            </Button>,
            <Button key="back" onClick={this.handleOk}>Cancel Subscription</Button>,
          ]}
        >
          Cancellation Reason:
         <TextArea placeholder="Cancellation Reason" name="cancelReason" rows={5} onChange={this.onChange}/>
        </Modal>
        <Modal
          visible={isDangerModalOpen}
          title="Cancel Subscription"
          onCancel={this.handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleYes}>
              Yes
            </Button>,
            <Button key="back" onClick={this.handleCancel}>No</Button>,
          ]}
        >
          Are you sure you want to cancel your subscription to OptionsEDU?
        </Modal>
        <Modal
          visible={isAccountModalOpen}
          title="Delete Account Information."
          onCancel={this.handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={this.handleAccountYes}>
              Yes
            </Button>,
            <Button key="back" onClick={this.handleCancel}>No</Button>,
          ]}
        >
          DANGER: All information that you have associated with OptionsEDU will be deleted. Are you sure you want to continue and delete?
        </Modal>
      </Fragment>
    );
  }
}

export default Subscription



// WEBPACK FOOTER //
// ./src/components/user-profile/Subscription.js